export function getAudioContextConstructor(): typeof AudioContext {
  if (typeof AudioContext !== 'undefined') {
    return AudioContext;
  }
  return (window as any).webkitAudioContext;
}
